;(async () => {
  // This is used as a backup if free gift wasn't added to cart via ajax
  const freeGiftBoxes = [40213882306623, 40213880242239]
  const freeGiftId = 29455597666327

  // Get current cart
  const getCart = async () => {
    const result = await fetch('/cart.js')
    return result.json()
  }

  // Adds items to cart
  const addCartItem = async () => {
    const items = [
      {
        id: freeGiftId,
        quantity: 1,
        properties: {
          type: 'Free Gift',
        },
      },
    ]

    const result = await fetch('/cart/add.js', {
      body: JSON.stringify({ items }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    return result.json()
  }

  // Checks if cart has box items and no gift item
  const hasUnprocessedItems = (items) => {
    const hasGiftBoxItems = items.find((item) => {
      return freeGiftBoxes.includes(item.variant_id)
    })

    const hasGiftItem = items.find((item) => {
      return item.id === freeGiftId
    })

    return hasGiftBoxItems && !hasGiftItem
  }

  // Run script
  const init = async () => {
    const { items } = await getCart()

    if (!hasUnprocessedItems(items)) return

    await addCartItem()

    window.location.reload()
  }

  init()
})()
